import { render, staticRenderFns } from "./singleNew.vue?vue&type=template&id=d5c54136&"
import script from "./singleNew.vue?vue&type=script&lang=js&"
export * from "./singleNew.vue?vue&type=script&lang=js&"
import style0 from "./singleNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports